// 预设头像表（与后端 users.js setAvatar 校验的索引 0~11 一致）
import { rankLabel } from './api';

export const AVATAR_EMOJIS: string[] = ['♟️', '🐢', '🦊', '🐱', '🐶', '🐼', '🦉', '🐯', '🐸', '🦁', '🐰', '🐨'];

/** AI 引擎座位图标（后端 avatar = -1） */
export const AI_AVATAR_GLYPH = '🤖';

/**
 * 头像字形：
 * - avatar = -1 → 引擎图标
 * - avatar 在预设范围内 → 对应 emoji
 * - 其他（旧数据/缺省）→ 昵称首字占位（保持原占位行为）
 */
export function avatarGlyph(avatar: number | null | undefined, nickname?: string | null): string {
  if (avatar === -1) return AI_AVATAR_GLYPH;
  if (typeof avatar === 'number' && avatar >= 0 && avatar < AVATAR_EMOJIS.length) return AVATAR_EMOJIS[avatar];
  return (nickname || '棋').slice(0, 1);
}

/** 座位级位文本：真实 rank → rankLabel；AI/无 rank 座位不再显示“—” */
export function seatRankText(seat: { rank?: number | null; avatar?: number } | null | undefined): string {
  if (!seat) return '—';
  if (seat.rank != null) return rankLabel(seat.rank);
  if (seat.avatar === -1) return 'AI';
  return '未定级';
}
